"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchSUMO1UserSaga = void 0;
const constants_1 = require("@/app/shared/constants");
const notifications_1 = require("@/app/shared/store/notifications");
const helpers_1 = require("@/app/shared/helpers");
const analyticsService_1 = require("@/app/shared/services/analyticsService");
const global_1 = require("@/app/shared/store/global");
const reduxUtils_1 = require("@/app/shared/store/reduxUtils");
const server_1 = require("@/app/SUMO/server");
const scheduler_1 = require("@/app/SUMO/store/scheduler");
const aws_amplify_1 = require("aws-amplify");
const effects_1 = require("redux-saga/effects");
const actions_1 = require("./actions");
const reducer_1 = require("./reducer");
const selectors_1 = require("./selectors");
const constants_2 = require("./constants");
const utils_1 = require("./utils");
function* initializeUser(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.INITIALIZE_USER)
        return;
    try {
        const isAuthorized = yield (0, effects_1.call)(server_1.SumoServer.isAuthorized);
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.setIsAuthorized(isAuthorized));
        if (isAuthorized) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationRequest());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationFail());
        yield (0, effects_1.put)(global_1.globalActions.handleLogout());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_MAIN_DATA_ERROR_MESSAGE);
    }
}
function* getAuthenticationRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.GET_AUTHENTICATION_REQUEST)
        return;
    try {
        const response = yield (0, effects_1.call)(server_1.SumoServer.getAuthenticationResponse);
        if (response) {
            if (response?.tenant) {
                yield (0, effects_1.put)(actions_1.SUMO1UserActions.setIsLicenseValid((0, utils_1.checkLicenseValidity)(response)));
            }
            if (response?.userData) {
                yield (0, effects_1.put)(actions_1.SUMO1UserActions.setUser(response.userData));
            }
            if (response?.role?.name) {
                yield (0, effects_1.put)(actions_1.SUMO1UserActions.setRole(response.role.name));
            }
            if (response.workspaces) {
                const currentUserActiveWorkspaces = response.workspaces.filter((workspace) => !workspace.isReadOnly && workspace.isActive);
                // if no admin and no active workspaces
                if (!response.role?.workspaceAdminActions?.includes("READ" /* PermissionAction.READ */) && !currentUserActiveWorkspaces?.length) {
                    throw new Error(constants_1.CLIENT_ERROR_CODES.NO_ACTIVE_WORKSPACES);
                }
            }
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationSuccess());
            analyticsService_1.analyticsService.trackAuthCompleted();
        }
    }
    catch (error) {
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_MAIN_DATA_ERROR_MESSAGE);
        yield (0, effects_1.delay)(constants_1.TOAST_SUCCESS_DURATION);
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationFail());
        yield (0, effects_1.put)(global_1.globalActions.handleLogout());
    }
}
function* getLoginWithGoogleRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_REQUEST)
        return;
    const isOutlookAddon = !!window?.Office?.context?.ui;
    try {
        const responce = yield (0, effects_1.call)(server_1.SumoServer.getGoogleAccessToken, { login: true, isOutlookAddon });
        if (responce) {
            const isAuthorized = yield (0, effects_1.select)(selectors_1.SUMO1UserSelectors.selectIsAuthorized);
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithGoogleSuccess());
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithGoogleAuthorizationRequest({
                ...responce,
                code: responce.access_token,
                isAuthorized,
                isOutlookAddon,
            }));
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithGoogleFail());
    }
}
function* getLoginWithGoogleAuthorizationRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_REQUEST)
        return;
    const isOutlookAddon = !!window?.Office?.context?.ui;
    try {
        const user = yield (0, effects_1.call)(server_1.SumoServer.loginWithGoogleAuthorizationCode, { ...action.payload, isOutlookAddon });
        if (user) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithGoogleAuthorizationSuccess());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithGoogleAuthorizationFail());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
    }
}
function* getLoginWithMicrosoftRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_REQUEST)
        return;
    const isOutlookAddon = !!window?.Office?.context?.ui;
    try {
        const responce = yield (0, effects_1.call)(server_1.SumoServer.getMicrosoftAccessToken, { isOutlookAddon });
        if (responce) {
            const isAuthorized = yield (0, effects_1.select)(selectors_1.SUMO1UserSelectors.selectIsAuthorized);
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithMicrosoftSuccess());
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithMicrosoftAuthorizationRequest({
                ...responce,
                isAuthorized,
                isOutlookAddon,
            }));
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithMicrosoftFail());
    }
}
function* connectGoogleContactsSaga(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.CONNECT_GOOGLE_CONTACTS_REQUEST)
        return;
    const isOutlookAddon = !!window?.Office?.context?.ui;
    try {
        const user = yield (0, effects_1.select)(selectors_1.SUMO1UserSelectors.selectUser);
        const responce = yield (0, effects_1.call)(server_1.SumoServer.getGoogleAuthorizationCode, {
            isOutlookAddon,
            loginHint: user?.email ?? undefined,
        });
        if (!responce?.code) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.connectGoogleContactsFail());
            return;
        }
        yield (0, effects_1.call)(server_1.SumoServer.connectGoogleContacts, { code: responce.code });
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.connectGoogleContactsSuccess());
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationRequest());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.connectGoogleContactsFail());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
    }
}
function* getLoginWithMicrosoftAuthorizationRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_REQUEST)
        return;
    const isOutlookAddon = !!window?.Office?.context?.ui;
    try {
        const user = yield (0, effects_1.call)(server_1.SumoServer.loginWithMicrosoftAuthorizationCode, { ...action.payload, isOutlookAddon });
        if (user) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithMicrosoftAuthorizationSuccess());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithMicrosoftAuthorizationFail());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
    }
}
function* handleLogout(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.HANDLE_LOGOUT)
        return;
    try {
        const isLoggedOut = yield (0, effects_1.call)(server_1.SumoServer.logout);
        if (isLoggedOut) {
            analyticsService_1.analyticsService.reset();
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.resetWholeStore());
            yield (0, effects_1.put)(scheduler_1.SUMO1SchedulerActions.resetWholeStore());
            yield (0, effects_1.put)(global_1.globalActions.setIsAuthorized(false));
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, { type: constants_1.RegularMessage.SCHEDULER_LOGOUT });
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, { type: constants_1.RegularMessage.SCHEDULER_DIALOG_CLOSE });
        }
    }
    catch (error) {
        console.error('Logout failed:', error);
    }
}
function* getLoginWithPasswordRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_PASSWORD_REQUEST)
        return;
    try {
        const { email, password } = action.payload;
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const result = yield (0, effects_1.call)(server_1.SumoServer.signInWithPassword, email, password, userTimeZone);
        if (result.mfaRequired) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithPasswordSuccess());
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.setLoginStep(reducer_1.LoginStep.MFA));
        }
        else if (result.authResponse) {
            helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_TYPE, "SUMO" /* ServerType.SUMO */);
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithPasswordSuccess());
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.setIsAuthorized(true));
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationRequest());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getLoginWithPasswordFail());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
    }
}
function* confirmMfaRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.CONFIRM_MFA_REQUEST)
        return;
    try {
        const { code, saveDevice } = action.payload;
        const email = yield (0, effects_1.select)(selectors_1.SUMO1UserSelectors.selectLoginEmail);
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        yield (0, effects_1.call)(server_1.SumoServer.confirmMfaCode, code);
        if (saveDevice) {
            yield (0, effects_1.call)([aws_amplify_1.Auth, aws_amplify_1.Auth.rememberDevice]);
        }
        const authResponse = yield (0, effects_1.call)(server_1.SumoServer.completePasswordAuth, email, userTimeZone);
        if (authResponse) {
            helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_TYPE, "SUMO" /* ServerType.SUMO */);
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.confirmMfaSuccess());
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.setIsAuthorized(true));
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationRequest());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.mfaSetError(constants_2.MfaError.INCORRECT_CODE));
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.confirmMfaFail());
    }
}
function* checkEmailSaga() {
    try {
        const email = yield (0, effects_1.select)(selectors_1.SUMO1UserSelectors.selectSsoEmail);
        const result = yield (0, effects_1.call)(server_1.SumoServer.checkEmail, email);
        // Check if SSO is available
        if (result.idpUrl && result.samlRequest) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.getSSOFormSuccess({
                idpUrl: result.idpUrl,
                samlRequest: result.samlRequest,
            }));
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.checkEmailSuccess());
            return;
        }
        // No SSO - check if user has password
        if (result.hasPassword) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.setLoginStep(reducer_1.LoginStep.PASSWORD));
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.checkEmailSuccess());
            return;
        }
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.setSSOEmailError(true));
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.checkEmailSuccess());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.setSSOEmailError(true));
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.checkEmailFail());
    }
}
function* forgotPasswordRequest(action) {
    if (action.type !== actions_1.SUMO1UserActionTypes.FORGOT_PASSWORD_REQUEST)
        return;
    try {
        yield (0, effects_1.call)(server_1.SumoServer.forgotPassword, action.payload);
        yield (0, effects_1.put)(notifications_1.notificationsActions.showToast({ id: constants_1.TOAST_ERROR_ID.FORGOT_PASSWORD_SUCCESS_MESSAGE }));
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.forgotPasswordSuccess());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.forgotPasswordFail());
        const err = error;
        const toastId = err?.code === 'UserNotFoundException' || err?.name === 'UserNotFoundException'
            ? constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE
            : constants_1.TOAST_ERROR_ID.GET_USER_AUTH_ERROR_MESSAGE;
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, toastId);
    }
}
function* getSSOFormRequest() {
    try {
        const email = yield (0, effects_1.select)(selectors_1.SUMO1UserSelectors.selectSsoEmail);
        const response = yield (0, effects_1.call)(server_1.SumoServer.checkSSOAuth, { email });
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getSSOFormSuccess(response));
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getSSOFormFail());
    }
}
// Root saga
function* watchSUMO1UserSaga() {
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.INITIALIZE_USER, initializeUser);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_AUTHENTICATION_REQUEST, getAuthenticationRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_REQUEST, getLoginWithGoogleRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_REQUEST, getLoginWithMicrosoftRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_REQUEST, getLoginWithGoogleAuthorizationRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_REQUEST, getLoginWithMicrosoftAuthorizationRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.CONNECT_GOOGLE_CONTACTS_REQUEST, connectGoogleContactsSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_LOGIN_WITH_PASSWORD_REQUEST, getLoginWithPasswordRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.CONFIRM_MFA_REQUEST, confirmMfaRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.CHECK_EMAIL_REQUEST, checkEmailSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.FORGOT_PASSWORD_REQUEST, forgotPasswordRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.GET_SSO_FORM_REQUEST, getSSOFormRequest);
    yield (0, effects_1.takeLatest)(actions_1.SUMO1UserActionTypes.HANDLE_LOGOUT, handleLogout);
}
exports.watchSUMO1UserSaga = watchSUMO1UserSaga;
